import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from './assets/js/axios.js'
import ElementUI from 'element-ui'
import qs from 'qs'
import 'element-ui/lib/theme-chalk/index.css'
import Common from '@/assets/js/common.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import AmapVue from '@amap/amap-vue'

import 'swiper/swiper-bundle.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.use(ElementUI);

axios.interceptors.response.use(res => {
  if (res.data.code == 2 && (location.pathname.indexOf('/service') != -1 || location.pathname == '/user')) {
    store.state.loginStatus = false;
    location.href = '/login';
  } else if (res.data.code == 3) {
    Vue.prototype.$confirm('余额不足，是否前往充值？', {
      confirmButtonText: '是',
      cancelButtonText: '否',
      center: true
    }).then(() => {
      store.state.rechargeShow = true;
    }).catch(info => {})
  }
  return res;
}, err => {
  console.log(err);
})

Vue.prototype.$global = Common
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.$store = store

Vue.config.productionTip = false

AmapVue.config.key = '99e66b4fdfe1fb5f180a00f92b5bf514';
AmapVue.config.plugin = ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']

Vue.use(AmapVue);

new Vue({
  axios,
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js